import { GridCellProps } from "@progress/kendo-react-grid";
import React from "react";
import { VobAssignmentRemoveCommand as RemoveCommand } from "../../../../services/profileService/commands";
import { Profile } from "../../../../services/profileService";
import { useRemoveVobAssignmentMutation } from "../../../../services/profileService/profile-api";
import { GridButton } from "../../../../components";
import DeleteIcon from '@mui/icons-material/Delete';

interface ownProps extends GridCellProps {
    profile: Profile;
}

function VobAssignmentRemoveCommand(props: ownProps) {
    const [removeVobAssignment] = useRemoveVobAssignmentMutation();

    const handleRemove = () => {
        // Remove entire assignment (all locations for this type/process)
        const command = new RemoveCommand(
            props.profile!.upn,
            props.dataItem.assignmentTypeCode,
            props.dataItem.processTypeCode
        );
        removeVobAssignment(command);
    }

    return <React.Fragment>
        <GridButton className='ms-1 mt-1' variant="outlined" onClick={() => handleRemove()}><DeleteIcon /></GridButton>
    </React.Fragment>
}

export { VobAssignmentRemoveCommand };
